<script>
  import Page from '@components/page'
  import Form from '@components/forms'
  import Button from '@components/buttons/button.svelte'
  import slugify from 'slugify'
  import { Link, Pencil } from 'lucide-svelte'

  let { form, programme = null } = $props()

  let keyEditing = $state(false)
  let keyInput = $state(null)

  export function onNameInput() {
    if (keyEditing) return
    $form.key = slugify($form.name, { lower: true, strict: true })
  }

  function toggleKeyEditing() {
    keyEditing = !keyEditing
    if (keyEditing) keyInput?.select()
  }
</script>

<Page.Content class="gap-6 xl:flex-row xl:items-start">

  <main class="xl:w-[66%] flex flex-col gap-6">
    <Form.Fieldset label="Details">
      <Form.Items>
        <Form.Item name="name" bind:value={$form.name} label="Name" hint="A descriptive name for the programme" cols={12} oninput={onNameInput} required />
      </Form.Items>
      <Form.Item name="description" label="Description" type="richtext" bind:value={$form.description} class="mt-4" />
    </Form.Fieldset>
  </main>

  <aside class="xl:w-[31%] flex flex-col gap-6">
    <Form.Fieldset label="Settings">
      <Form.Items>
        <Form.Item name="key" bind:inputRef={keyInput} bind:value={$form.key} label="Key" hint="A unique identifier for the programme" cols={12} readonly={!keyEditing} inputClass={keyEditing ? '' : 'italic opacity-80'} required>
          {#snippet suffix()}
            <Button variant="naked" Icon={keyEditing ? Pencil : Link} onclick={toggleKeyEditing} class={keyEditing ? '' : 'opacity-60'} tabIndex={-1} />
          {/snippet}
        </Form.Item>

        <Form.Item name="starts_on" type="date" bind:value={$form.starts_on} label="Starts on" hint="The date the programme will run from" cols={12} max={$form.ends_on} />
        <Form.Item name="ends_on" type="date" bind:value={$form.ends_on} label="Ends on" hint="The date the programme will end" cols={12} min={$form.starts_on} />
      </Form.Items>
    </Form.Fieldset>
  </aside>

</Page.Content>
